import { NewtopiaBottomCards, NewtopiaMarketCard, NewtopiaTopCards } from './NewtopiaCards';

export const Tablet = () => {
	return (
		<div className='newtopiaTablet'>
			<div className='cardContainer'>
				<NewtopiaTopCards
					className='topCardContainer'
					privateTitle='Private Label'
					cleanLabelTitle='Clean Label'
				/>
				<NewtopiaMarketCard wrapperClassName='midCardContainer' cardClassName='cardNewtoMarket' />
				<NewtopiaBottomCards className='bottomCardContainer' />
				<div className='newtopiawave'></div>
			</div>
			<div className='footer'></div>
		</div>
	);
};
